__webpack_require__.p = "https://assets.hexahome.in/hexadecimal-software-blog/";